import React from 'react';
import PropTypes from 'prop-types';
import PipelineTransformationsYamlEditor from '../shared/PIpelineTransformationsYamlEditor';
import PipelineTransformationsDrawerHeader from '../shared/PipelineTransformationsDrawerHeader';

export default function PipelineFiltersDrawerContent({ filters }) {
  return (
    <>
      <PipelineTransformationsDrawerHeader
        title="Pipeline Filters"
        documentationUrl="https://docs.metarouter.io/docs/configuring-pipelines#pipeline-filters"
      />
      <PipelineTransformationsYamlEditor name="pipeline-filters" value={filters} />
    </>
  );
}

PipelineFiltersDrawerContent.propTypes = {
  filters: PropTypes.object.isRequired,
};
